// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"paginationContainer--TkwsW"};